import {Component, ViewChild} from '@angular/core';
import {
  AlertController,
  Config,
  List,
  ModalController,
  NavController,
  NavParams,
  PopoverController,
  ToastController
} from 'ionic-angular';
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {VorlageneditorInspectionpointDetailsPage} from "../vorlageneditor-inspectionpoint-details/vorlageneditor-inspectionpoint-details";
import {ModalNavPage} from "../modal-nav/modal-nav";
import {VorlageneditorMasterdataDetailsPage} from "../vorlageneditor-masterdata-details/vorlageneditor-masterdata-details";
import {SharePruefungPopover} from "../pruefung/pruefung";
import {Network} from "@ionic-native/network";
import {HttpClient} from "@angular/common/http";
import {GlobalProvider} from "../../providers/global/global";
import {TemplateService} from "../../store/template/template.service";

/**
 * Generated class for the VorlageneditorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

type reviews = Array<{ title: string, icon: string, color: string, danger: number }>;


@Component({
  selector: 'page-vorlageneditor',
  templateUrl: 'vorlageneditor.html',
})
export class VorlageneditorPage {

  @ViewChild('inspectionList') inspectionList: List;

  public editMode: boolean = false;
  public deleteable: boolean = false;
  public canReorderMasterData: boolean = false;
  public canReorderInspectionResult: boolean = false;

  public _mode: any;
  public canReorder: Array<boolean> = [];
  public canReorderSections: boolean = false;

  public title: string = "";
  public objectName: string = "";
  public coverTitle: string = "";
  public masterData: Array<{ type: string, title: string, list?: Array<string> }> = [];
  public inspectionPoints: Array<{ propertyName: string, title: string, reviews: reviews }> = [];

  public sections: Array<{ title: string, inspectionPoints: Array<{ propertyName: string, title: string }> }> = [];
  public inspectionResults: Array<{ propertyName: string, title: string, value: boolean }> = [];
  public template: any = {
    title: this.title,
    objectName: this.objectName,
    masterData: this.masterData,
    sections: this.sections,
    inspectionResults: this.inspectionResults,
    coverTitle: this.coverTitle
  };

  // public templates: Observable<Array<any>>;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private alertCtrl: AlertController,
              // private dataProvider: DataProvider,
              private toastCtrl: ToastController,
              public _config: Config,
              public modalCtrl: ModalController,
              private network: Network,
              private http: HttpClient,
              private globalProvider: GlobalProvider,
              private popoverCtrl: PopoverController,
              public templateService: TemplateService) {
    // this.templates = this.dataProvider.getAllObsDocsByType('template');
    this._mode = _config.get('mode');
  }

  public backButtonClick() {
    this.editMode = !this.editMode;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VorlageneditorPage');
  }

  public newStammdate(): void {
    if (!this.template.masterData) {
      this.template.masterData = [];
    }
    this.template.masterData.push({type: "text", title: "", list: []});
  }

  public newPruefpunkt(section: any): void {

    let newInspectionPoint = {propertyName: new Date().getMilliseconds().toString(), title: '', reviews: []};

    //wenn die Sektion bereits einen Prüfpunkt hat, dann werden die daten aus dem vorherigen Prüfpunkt in den neuen übernommen
    if (section.inspectionPoints && section.inspectionPoints.length > 0) {
      newInspectionPoint = JSON.parse(JSON.stringify(section.inspectionPoints[section.inspectionPoints.length - 1]));
      newInspectionPoint.propertyName = new Date().getMilliseconds().toString();
      newInspectionPoint.title = newInspectionPoint.title + ' (Kopie)';
    }

    section.inspectionPoints.push(newInspectionPoint);
  }

  public newSection(): void {
    this.template.sections.push({title: "", inspectionPoints: []});
  }

  public newErgebnis(): void {
    this.template.inspectionResults.push({
      propertyName: new Date().getMilliseconds().toString(),
      title: "",
      value: true
    });
  }

  public removePruefpunkt(section, inspectionPoint): void {
    section.inspectionPoints = section.inspectionPoints.filter((_inspectionPoint) => {
      return _inspectionPoint !== inspectionPoint;
    })
  }

  public removeSection(section: any) {

    let alert = this.alertCtrl.create({
      title: 'LÖSCHEN!',
      subTitle: 'Möchten Sie die Sektion "' + section.title + '" und deren Prüfpunkte wirklich löschen?',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
            //this.inspectionList.closeSlidingItems();
          }
        },
        {
          text: 'Bestätigen',
          handler: () => {
            console.log('try to remove section');
            this.template.sections = this.template.sections.filter((_section) => {
              return _section !== section;
            });
          }
        }
      ]
    });
    alert.present();
  }

  public removeErgebnis(inspectionResult): void {
    this.inspectionResults = this.inspectionResults.filter((_inspectionResult) => {
      return _inspectionResult !== inspectionResult;
    })
  }

  public saveTemplate(): void {
    //zuerst prüfpunkte löschen die keinen Text haben und danach sectionen die keine pruefpunkte beinhalten
    let _template: any = {...this.template};
    _template.sections = _template.sections.filter((_section) => {
      _section.inspectionPoints = _section.inspectionPoints.filter((_inspectionPoint) => {
        return _inspectionPoint.title.length !== 0;
      });
      return _section.inspectionPoints.length !== 0;
    });

    _template.inspectionResults = _template.inspectionResults.filter((_inspectionResult) => {
      return _inspectionResult.title.length !== 0;
    });

    if (_template._id) {
      //update
      this.templateService.set(_template, false);
      // this.dataProvider.updateDocument(_template);
    }
    else {
      //new Template
      const newTemplate = {
        docType: "template",
        docName: 'Prüfvorlage',
        lang: 'de_DE',
        ..._template
      };
      this.templateService.add(newTemplate, false);
      // this.dataProvider.createDocumentWithoutInit({
      //   docType: "template",
      //   docName: 'Prüfvorlage',
      //   lang: 'de_DE', ..._template
      // });
    }
    this.editMode = false;
  }

  public setEditTemplate(template): void {
    this.template = JSON.parse(JSON.stringify(template));
    this.editMode = true;
  }

  public delete(): void {
    let alert = this.alertCtrl.create({
      title: 'LÖSCHEN!',
      subTitle: 'Möchten Sie diese Vorlage unwiderruflich löschen?',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Bestätigen',
          handler: () => {
            this.templateService.remove(this.template, false);
            this.editMode = false;
          }
        }
      ]
    });
    alert.present();
  }

  public newTemplate(): void {
    this.title = "";
    this.objectName = "";
    this.masterData = [];
    this.sections = [];
    this.inspectionResults = [];
    this.coverTitle = "";

    this.template = {
      title: this.title,
      objectName: this.objectName,
      masterData: this.masterData,
      sections: this.sections,
      inspectionResults: this.inspectionResults,
      coverTitle: this.coverTitle
    };

    this.editMode = true;
  }

  public copyTemplate(): void {
    let _copy = JSON.parse(JSON.stringify(this.template));
    _copy.title = _copy.title + ' (Kopie)';
    delete _copy._id;
    delete _copy._rev;
    delete _copy.system;

    this.templateService.add(_copy, false)
      .then((newTemplate) => {
        this.toastCtrl.create({
          message: 'Vorlage wurde erfolgreich dupliziert',
          duration: 1000,
          position: 'bottom'
        }).present();
        this.template = newTemplate;
      }, () => {
        this.toastCtrl.create({
          message: 'Fehler beim duplizieren der Vorlage',
          duration: 1000,
          position: 'bottom'
        }).present();
      })

    // this.dataProvider.createDocumentWithoutInit(_copy)
    //   .then((newTemplate) => {
    //     this.toastCtrl.create({
    //       message: 'Vorlage wurde erfolgreich dupliziert',
    //       duration: 1000,
    //       position: 'bottom'
    //     }).present();
    //     this.template = newTemplate;
    //   }, (error) => {
    //     this.toastCtrl.create({
    //       message: 'Fehler beim duplizieren der Vorlage',
    //       duration: 1000,
    //       position: 'bottom'
    //     }).present();
    //   })
  }

  public enableReorderMasterData(masterDataList: List): void {
    masterDataList.sliding = this.canReorderMasterData;
    this.canReorderMasterData = !this.canReorderMasterData;
  }

  public reorderMasterData(indexes, masterDataList: List): void {
    console.dir(indexes);
    let element = this.template.masterData[indexes.from];
    this.template.masterData.splice(indexes.from, 1);
    this.template.masterData.splice(indexes.to, 0, element);
  }

  public enableInspectionPointReorder(propertyName): void {
    for (let index in this.canReorder) {
      if (index !== propertyName) {
        this.canReorder[index] = false;
      }
    }
    this.canReorder[propertyName] = !this.canReorder[propertyName];
  }

  public reorder(indexes, source: Array<any>): void {
    console.dir(indexes);
    let element = source[indexes.from];
    source.splice(indexes.from, 1);
    source.splice(indexes.to, 0, element);
  }

  public deleteMasterDataItem(item: any): void {
    var itemToRemove = JSON.stringify(item);
    this.template.masterData = this.template.masterData.filter((_item) => {
      return JSON.stringify(_item) !== itemToRemove;
    })
  }

  public openInspectionPointDetails(inspectionPoint: any): void {

    let inspectionPointDetailModal = this.modalCtrl.create(ModalNavPage, {
      page: VorlageneditorInspectionpointDetailsPage,
      param: {inspectionPoint: inspectionPoint, isSystem: this.template.system}
    });
    inspectionPointDetailModal.onDidDismiss((data) => {
      if (data) {
        inspectionPoint = data.inspectionPoint;
      }
    });
    inspectionPointDetailModal.present();
  }

  public openMasterDataDetails(data: any): void {
    let masterDataModal = this.modalCtrl.create(VorlageneditorMasterdataDetailsPage, {masterData: data});
    masterDataModal.onDidDismiss((data) => {

    })
    masterDataModal.present();
  }

  public removeInspectionResult(inspectionResult: any) {
    this.template.inspectionResults = this.template.inspectionResults.filter((_inspectionResult) => {
      return _inspectionResult !== inspectionResult;
    })
  }

  public share(event): void {
    //check Connection
    //if networkconnection available -> get TeamMembers and exlude current owner.
    //after select -> rewrite owner of pruefung to
    if (this.network.type !== 'none') {
      //request Teammember and exclude owner
      this.http.post(this.globalProvider.apiURL + '/v1/teammembers', {
        userUUID: this.globalProvider.user.uuid,
        databaseUUID: this.globalProvider.database.uuid
      })
        .subscribe((response: any) => {
          if (response.meta.success) {
            let availableShareUsers = response.data.availableShareUsers;
            let sharePopover = this.popoverCtrl.create(SharePruefungPopover, {availableShareUsers: availableShareUsers});
            sharePopover.onDidDismiss((response) => {
              if (response) {
                console.log('share data with user: ');
                console.dir(response.selectedShareUser);
                //we have now the needed information to set the ownerId of this document. @refercenced customer add the selectedShareUser
                if (!this.template.hasOwnProperty('readers')) {
                  this.template['readers'] = [];
                }
                this.template.readers = this.template.readers.filter((reader) => {
                  return reader !== response.selectedShareUser.userUUID;
                });
                this.template.readers.push(response.selectedShareUser.userUUID);
                this.templateService.set(this.template, false);
                // this.dataProvider.updateDocument(this.template);
              }
            })
            sharePopover.present({
              ev: event
            });
          } else {
            //alert error
          }
        })
    } else {
      //alert user, that we need a network connection
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/vorlageneditor/vorlageneditor.ts